var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountPaymentGuideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 2.39999H10.8C11.1713 2.39999 11.5274 2.54749 11.7899 2.81004C12.0525 3.0726 12.2 3.42869 12.2 3.79999V13.6C12.2 13.9713 12.0525 14.3274 11.7899 14.5899C11.5274 14.8525 11.1713 15 10.8 15H2.4C2.0287 15 1.6726 14.8525 1.41005 14.5899C1.1475 14.3274 1 13.9713 1 13.6V3.79999C1 3.42869 1.1475 3.0726 1.41005 2.81004C1.6726 2.54749 2.0287 2.39999 2.4 2.39999H3.8",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69999 1H4.49999C4.31434 1 4.13629 1.07375 4.00501 1.20503C3.87374 1.3363 3.79999 1.51435 3.79999 1.7V3.1C3.79999 3.28565 3.87374 3.4637 4.00501 3.59497C4.13629 3.72625 4.31434 3.8 4.49999 3.8H8.69999C8.88564 3.8 9.06369 3.72625 9.19496 3.59497C9.32624 3.4637 9.39999 3.28565 9.39999 3.1V1.7C9.39999 1.51435 9.32624 1.3363 9.19496 1.20503C9.06369 1.07375 8.88564 1 8.69999 1V1Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59998 7.3H9.39998",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59998 10.8H9.39998",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79999 7.3H3.80699",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79999 10.8H3.80699",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPaymentGuideIcon);
export default __webpack_public_path__ + "static/media/account_payment_guide_icon.f17f6f6e82692891c3e18ecf1f138c3a.svg";
export { ForwardRef as ReactComponent };